module.exports = __webpack_public_path__ + "static/media/virgin-trains-logo.263e8371.svg";